import {css, StyleSheet} from 'aphrodite';
import React, {useState} from 'react';
import _ from 'underscore';

import LegacyFieldError from 'ui-library/bs/LegacyFieldError';
import {ButtonStyle} from 'ui-library/buttons/Button';
import HorizontalChipListField from 'ui-library/chips/HorizontalChipListField';
import Modal from 'ui-library/modals/Modal';
import WorklistSelector, {WorklistSelectorDetails} from 'worklists/WorklistSelector';

import {ValidateWorklistItems, Worklist, WorklistType} from './WorklistConstants';

export interface SelectWorklistModalProps {
  onRequestClose: () => void;
  onRequestSubmit: (worklist: Worklist) => void;
  worklistTypes: Array<WorklistType>;
  validateItems?: ValidateWorklistItems;
}

export default function SelectWorklistModal(props: SelectWorklistModalProps): JSX.Element {
  const [details, setDetails] = useState<WorklistSelectorDetails | null>(null);

  function handleSubmit(): void {
    // Items must not be archived or inaccessible, and must have passed the consumer-defined
    // validation function (if one was provided).
    const idsToSubmit = _.difference(
      details!.worklist!.itemIds,
      details!.worklist!.archivedItemIds,
      details!.worklist!.inaccessibleItemIds,
      details!.badItemIds
    );

    props.onRequestSubmit({...details!.worklist!, itemIds: idsToSubmit});
  }

  return (
    <Modal
      onRequestClose={props.onRequestClose}
      title="Select worklist"
      onRequestSubmit={handleSubmit}
      buttons={[
        {
          submit: true,
          text: details?.isValidating ? 'Validating worklist...' : 'Select worklist',
          disabled: details?.worklist == null,
          style: ButtonStyle.SECONDARY,
        },
      ]}
    >
      <WorklistSelector
        onChange={setDetails}
        worklistTypes={props.worklistTypes}
        validateItems={props.validateItems}
      />
      <div className={css(styles.errorWrapper)}>
        {details && details.errorMessage && details.errorMessage.length > 0 && (
          <LegacyFieldError message={details.errorMessage} />
        )}
        {details && details.badItemIds.length > 0 ? (
          <HorizontalChipListField ids={details.badItemIds} title="Invalid items" />
        ) : null}
        {details?.infoMessage && (
          <div className="u-small-spacing-top u-small-spacing-bottom">{details?.infoMessage}</div>
        )}
      </div>
    </Modal>
  );
}

const styles = StyleSheet.create({
  errorWrapper: {
    marginTop: '10px',
  },
});
